var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 9.60039H20.3999C21.0626 9.60039 21.5999 10.1376 21.5999 10.8004L21.5999 19.6004C21.5999 20.705 20.7045 21.6004 19.5999 21.6004L10.7999 21.6004C10.1372 21.6004 9.5999 21.0631 9.5999 20.4004V18.0004M11.9999 2.40039L4.7999 2.40039C3.47442 2.40039 2.3999 3.47491 2.3999 4.80039L2.3999 12.0004C2.3999 13.3259 3.47442 14.4004 4.7999 14.4004L11.9999 14.4004C13.3254 14.4004 14.3999 13.3259 14.3999 12.0004L14.3999 4.80039C14.3999 3.47491 13.3254 2.40039 11.9999 2.40039Z",
    stroke: "#F8F7F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.f938e00817e61861c89447c6db3d1d16.svg";
export { ForwardRef as ReactComponent };